import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  const shopCategories = categories.slice(0, 7);
  const moreCategories = categories.slice(7);

  return (
    <footer className="bg-secondary-500 text-background-50">
      {/* Upper Footer */}
      <div className="w-full px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-10">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <Link to="/" className="font-heading text-2xl font-bold text-background-50 inline-block cursor-pointer">
              Superbuy Spreadsheet Hub.
              <span className="text-accent-500 ml-1">●</span>
            </Link>
            <p className="mt-4 text-background-100/70 text-sm leading-relaxed max-w-sm">
              The ultimate independent resource center for Superbuy spreadsheet finds, product research guides, QC tips, and shopping education. Helping shoppers discover better products through organized data.
            </p>
          </div>

          {/* Shop Links */}
          <div>
            <h4 className="font-label font-semibold text-sm text-background-50 mb-4 uppercase tracking-wider">Categories</h4>
            <ul className="space-y-2.5">
              {shopCategories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-background-100/60 text-sm hover:text-background-50 hover:underline transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* More Links */}
          <div>
            <h4 className="font-label font-semibold text-sm text-background-50 mb-4 uppercase tracking-wider">More</h4>
            <ul className="space-y-2.5">
              {moreCategories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-background-100/60 text-sm hover:text-background-50 hover:underline transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Guides */}
          <div>
            <h4 className="font-label font-semibold text-sm text-background-50 mb-4 uppercase tracking-wider">Guides</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/articles/superbuy-spreadsheet-guide" className="text-background-100/60 text-sm hover:text-background-50 hover:underline transition-colors whitespace-nowrap cursor-pointer">
                  Complete Guide
                </Link>
              </li>
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-background-100/60 text-sm hover:text-background-50 hover:underline transition-colors whitespace-nowrap cursor-pointer">
                  Superbuy Sheet
                </a>
              </li>
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-background-100/60 text-sm hover:text-background-50 hover:underline transition-colors whitespace-nowrap cursor-pointer">
                  Main Store
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-background-50/10">
        <div className="w-full px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-100/40 text-xs">
            &copy; 2026 Superbuy Spreadsheet Hub. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <span className="w-8 h-8 flex items-center justify-center rounded-lg border border-background-50/20 text-background-100/40 hover:text-background-50 hover:border-background-50/40 transition-colors cursor-pointer">
              <i className="ri-twitter-x-line text-sm"></i>
            </span>
            <span className="w-8 h-8 flex items-center justify-center rounded-lg border border-background-50/20 text-background-100/40 hover:text-background-50 hover:border-background-50/40 transition-colors cursor-pointer">
              <i className="ri-reddit-line text-sm"></i>
            </span>
            <span className="w-8 h-8 flex items-center justify-center rounded-lg border border-background-50/20 text-background-100/40 hover:text-background-50 hover:border-background-50/40 transition-colors cursor-pointer">
              <i className="ri-pinterest-line text-sm"></i>
            </span>
          </div>
          <p className="text-background-100/40 text-xs">
            <em>Independent resource. Not affiliated with Superbuy official services.</em>
          </p>
        </div>
      </div>
    </footer>
  );
}